
import { useTranslation } from 'react-i18next';

import { Route, Routes } from "react-router-dom";


import LocaleContext from './LocaleContext';
import { useEffect, useState } from 'react';
import Home from './views/home.jsx';
import Main from './page/main.jsx';
import Register from './page/auth/register.jsx';
import Login from './page/auth/login.jsx';

import { AuthContextProvider } from './components/shared/AuthContext';
import ProtectedRoute from './components/shared/ProtectedRoute';
import ResetPassword from './page/auth/reset_password';
import { OrgContextProvider } from './organisation/OrgContext';
import Maintenance from "./views/Maintenance.jsx";

function App() {

  const [t, i18n] = useTranslation();

  i18n.on('languageChanged', (lng) => setLocale(i18n.language));
  
  const [locale, setLocale] = useState(i18n.language);

  useEffect(()=>{
    const _checkLang = async () => {
      try {
        const value = await localStorage.getItem("lang");

        if(value != null){
          console.log("lang saved is ", value);
          i18n.changeLanguage(value);
        }else{
          console.log("no lang saved");
        }
      } catch (error) {
        console.error(error);
      }
    }

    _checkLang();
  }, []);

  //return <Home />;

  return (
    <LocaleContext.Provider value={{locale, setLocale}}>
      <AuthContextProvider>
        <OrgContextProvider>
        <Routes >

          <Route
              path="/*"
              element={
                <ProtectedRoute accessBy="authenticated">
                  <Main />
                </ProtectedRoute>
              }
              exact
            ></Route>

          <Route path="/login" element={
            <ProtectedRoute accessBy="non-authenticated">
              <Login />
            </ProtectedRoute>
            }></Route>
          
          {/*<Route path="/register" element={
            <ProtectedRoute accessBy="non-authenticated">
              <Register />
            </ProtectedRoute>
          }></Route>*/}

            <Route path="/reset_password" element={
            <ProtectedRoute accessBy="non-authenticated">
              <ResetPassword />
            </ProtectedRoute>
            }></Route>
         {/* // Maintenance  page */}
          <Route path="/maintenance" element={<Maintenance />} />
        </Routes>
        </OrgContextProvider>
      </AuthContextProvider>
      
    {/* <> */}
      
    {/* <Main/> */}

    {/* <Register /> */}

    {/* <Login/> */}
    
   {/* </> */}
   </LocaleContext.Provider>
  );
}

export default App;
